const topics = [
  { title: '娱乐圈吃瓜专区', count: '2.3万条', icon: 'ri-star-line', desc: '明星八卦、影视动态一站式追踪' },
  { title: '网红八卦集中营', count: '1.8万条', icon: 'ri-live-line', desc: '直播圈、短视频圈最新猛料' },
  { title: '综艺节目热议', count: '1.5万条', icon: 'ri-tv-line', desc: '热门综艺话题讨论与花絮合集' },
  { title: '社会热点解读', count: '2.1万条', icon: 'ri-fire-line', desc: '全网热搜事件深度吃瓜分析' },
  { title: '吃瓜大赛回放', count: '9800条', icon: 'ri-trophy-line', desc: '历届精彩赛事视频合集' },
  { title: '影视剧吐槽', count: '1.2万条', icon: 'ri-film-line', desc: '新剧老剧花式吐槽与评分' },
  { title: '电竞吃瓜前线', count: '8600条', icon: 'ri-gamepad-line', desc: '电竞赛事与选手最新动态' },
  { title: '时尚潮流瓜', count: '7200条', icon: 'ri-shirt-line', desc: '明星穿搭、品牌代言风向标' },
  { title: '海外吃瓜速递', count: '6400条', icon: 'ri-global-line', desc: '日韩欧美娱乐圈最新资讯' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            📂 吃瓜专题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            九大主题专区，精准定位你最想吃的瓜
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {topics.map((item, i) => (
            <a
              key={i}
              href="#index"
              onClick={(e) => e.preventDefault()}
              className="group flex items-start gap-4 p-5 bg-background-50 border border-background-200/70 rounded-xl transition-all duration-300 hover:border-primary-200/50 hover:bg-background-100 cursor-pointer"
            >
              <div className="flex-shrink-0 w-11 h-11 rounded-lg bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${item.icon} text-lg text-primary-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 whitespace-nowrap">
                    {item.title}
                  </h3>
                  <span className="text-xs text-primary-600 font-medium whitespace-nowrap ml-2">{item.count}</span>
                </div>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}